import React from 'react';

interface PaginationProps {
  canPreviousPage: boolean;
  canNextPage: boolean;
  pageCount: number;
  pageIndex: number;
  pageOptions: number[];
  pageSize: number;
  setPageSize: (size: number) => void;
  gotoPage: (page: number) => void;
  nextPage: () => void;
  previousPage: () => void;
}

const Pagination: React.FC<PaginationProps> = ({
  canPreviousPage,
  canNextPage,
  pageCount,
  pageIndex,
  pageOptions,
  pageSize,
  setPageSize,
  gotoPage,
  nextPage,
  previousPage
}) => {
  return (
    <div className="flex justify-start items-center gap-2 px-2 py-0 flex-wrap lg:justify-end">
      <button
        className="px-3 py-0 bg-primary2 border border-neutral2 rounded cursor-pointer transition duration-300 transform hover:bg-neutral2 disabled:opacity-50 disabled:cursor-not-allowed"
        onClick={() => gotoPage(0)}
        disabled={!canPreviousPage}
      >
        {'<<'}
      </button>
      <button
        className="px-3 py-0 bg-primary2 border border-neutral2 rounded cursor-pointer transition duration-300 transform hover:bg-neutral2 disabled:opacity-50 disabled:cursor-not-allowed"
        onClick={() => previousPage()}
        disabled={!canPreviousPage}
      >
        {'<'}
      </button>
      <button
        className="px-3 py-0 bg-primary2 border border-neutral2 rounded cursor-pointer transition duration-300 transform hover:bg-neutral2 disabled:opacity-50 disabled:cursor-not-allowed"
        onClick={() => nextPage()}
        disabled={!canNextPage}
      >
        {'>'}
      </button>
      <button
        className="px-3 py-0 bg-primary2 border border-neutral2 rounded cursor-pointer transition duration-300 transform hover:bg-neutral2 disabled:opacity-50 disabled:cursor-not-allowed"
        onClick={() => gotoPage(pageCount - 1)}
        disabled={!canNextPage}
      >
        {'>>'}
      </button>
      <span className="text-sm">
        Page{' '}
        <strong>
          {pageIndex + 1} of {pageOptions.length}
        </strong>
      </span>
      <span className="text-sm">
        | Go to page:
        <input
          type="number"
          className="ml-1 w-16 !p-0.5 !pl-1 text-sm rounded !border-neutral2"
          defaultValue={pageIndex + 1}
          onChange={(e) => {
            const pageNumber = e.target.value ? Number(e.target.value) - 1 : 0;
            gotoPage(pageNumber);
          }}
        />
      </span>
      <select
        className="p-1 text-sm rounded border border-neutral2"
        value={pageSize}
        onChange={(e) => setPageSize(Number(e.target.value))}
      >
        {[10, 20, 30, 40, 50].map((pageSizeOptions) => (
          <option key={pageSizeOptions} value={pageSizeOptions}>
            Show {pageSizeOptions}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Pagination;
